import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=62afc6b6&"
import script from "./VideoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports